import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { ScfV2Component } from './scf-v2.component';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { MatFormFieldDefaultOptions, MatFormFieldModule, MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { AppComponent } from 'src/app/app.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { HttpClientModule } from '@angular/common/http';
import { ReactiveFormsModule, FormsModule, FormControl, FormGroupDirective, NgForm } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { ErrorStateMatcher, MatNativeDateModule, MatOptionModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSortModule } from '@angular/material/sort';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatTreeModule } from '@angular/material/tree';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { QuillModule } from 'ngx-quill';
import { AppRoutingModule } from 'src/app/app-routing.module';
import { SharedModule } from 'src/app/modules/shared.module';
import { ScfV2SideComponent } from './scf-v2-side/scf-v2-side.component';
import { ScfV2SettingsComponent } from './scf-v2-settings/scf-v2-settings.component';
import { ScfV2SettingsPermissionsComponent } from './scf-v2-settings/scf-v2-settings-permissions/scf-v2-settings-permissions.component';
import { ScfV2SettingsSignaturesComponent } from './scf-v2-settings/scf-v2-settings-signatures/scf-v2-settings-signatures.component';
import { ScfV2SettingsNotificationsComponent } from './scf-v2-settings/scf-v2-settings-notifications/scf-v2-settings-notifications.component';
import { httpInterceptorProviders } from 'src/app/common/interceptors/interceptorProviders';
import { ScfV2MainS1Component } from './scf-v2-main/scf-v2-main-s1/scf-v2-main-s1.component';
import { ScfV2MainComponent } from './scf-v2-main/scf-v2-main.component';
import { ScfV2MainButtonsComponent } from './scf-v2-main/scf-v2-main-buttons/scf-v2-main-buttons.component';
import { ScfV2MainS2Component } from './scf-v2-main/scf-v2-main-s2/scf-v2-main-s2.component';
import { ScfV2MainS3Component } from './scf-v2-main/scf-v2-main-s3/scf-v2-main-s3.component';
import { ControlsModule } from 'src/app/controls/controls.module';
import { ScfV2MainS4Component } from './scf-v2-main/scf-v2-main-s4/scf-v2-main-s4.component';
import { ScfV2MainS4NoworkComponent } from './scf-v2-main/scf-v2-main-s4/scf-v2-main-s4-nowork/scf-v2-main-s4-nowork.component';
import { ScfV2MainS4HoldpointsComponent } from './scf-v2-main/scf-v2-main-s4/scf-v2-main-s4-holdpoints/scf-v2-main-s4-holdpoints.component';
import { ScfV2MainS5Component } from './scf-v2-main/scf-v2-main-s5/scf-v2-main-s5.component';
import { MatToolbarModule } from '@angular/material/toolbar';
import { RedirectGuard } from 'src/app/common/guards/redirect.guard';
import { AuthenticationGuard } from 'src/app/common/guards/authentication.guard';


class TouchedErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    return !!(control && control.invalid && (control.dirty || control.touched));
  }
}

const appRoutes: Routes = [
  { path: 'scfv2', component: ScfV2Component, canActivate: [AuthenticationGuard], canDeactivate: [RedirectGuard] },
];

const appearance: MatFormFieldDefaultOptions = {
  appearance: 'outline'
};

@NgModule({
  declarations: [
    ScfV2Component,
    ScfV2SideComponent,
    ScfV2MainComponent,
    ScfV2MainButtonsComponent,

    ScfV2MainS3Component,
    ScfV2MainS4Component,
    ScfV2MainS5Component,
    ScfV2SettingsComponent,
    ScfV2SettingsPermissionsComponent,
    ScfV2SettingsSignaturesComponent,

    ScfV2MainS4NoworkComponent,
    ScfV2SettingsNotificationsComponent,
  ],
  imports: [
    CommonModule,
    BrowserModule,
    NgbModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    MatMenuModule,
    MatButtonModule,
    MatDialogModule,
    HttpClientModule,
    ScrollingModule,
    HttpClientModule,
    MatSelectModule,
    MatFormFieldModule,
    MatInputModule,
    MatCheckboxModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatTableModule,
    MatSortModule,
    MatPaginatorModule,
    MatChipsModule,
    MatIconModule,
    ReactiveFormsModule,
    MatAutocompleteModule,
    MatListModule,
    MatProgressSpinnerModule,
    MatCardModule,
    MatRadioModule,
    // MatFileUploadModule,
    MatStepperModule,
    MatSlideToggleModule,
    MatTabsModule,
    MatTooltipModule,
    MatGridListModule,
    FormsModule,
    ReactiveFormsModule,
    MatProgressBarModule,
    DragDropModule,
    MatTreeModule,
    MatToolbarModule,
    MatExpansionModule,
    MatOptionModule,
    MatSidenavModule,
    DatePipe,

    QuillModule.forRoot(),
    RouterModule.forRoot(
      appRoutes,
      {
        enableTracing: true,
        useHash: true,
        anchorScrolling: 'enabled',
        preloadingStrategy: PreloadAllModules,
      }
    ),
    SharedModule,
    ControlsModule,
  ],
  exports: [
    RouterModule,
    ScfV2MainS1Component,
    ScfV2MainS2Component,
    ScfV2MainS4HoldpointsComponent,
    SharedModule
  ],
  providers: [
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: appearance
    },
    httpInterceptorProviders,
    { provide: ErrorStateMatcher, useClass: TouchedErrorStateMatcher }
  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class ScfV2Module { }
